import React from 'react';
import GraphAttachedTooltip from 'shared/college-profile/components/graph-attached-tooltip';

interface Props {
  classification: string;
  label: string;
  studentValue: number | string;
  xValue: number;
}

const AcceptanceClassificationTooltip = ({label, studentValue, classification, xValue}: Props) => (
  <GraphAttachedTooltip style={{left: `calc(${xValue}%)`}}>
    <div className="horizontal-box-plot-tooltip-label-text-container">
      <div>
        <span className="horizontal-box-plot-tooltip-text">{label}: </span>
        <span className="horizontal-box-plot-tooltip-text horizontal-box-plot-tooltip-emphasized">
          {studentValue}
        </span>
      </div>
      <div>
        <span className="horizontal-box-plot-tooltip-text">{classification}</span>
      </div>
    </div>
  </GraphAttachedTooltip>
);

export default AcceptanceClassificationTooltip;
